import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Typography, Button, CircularProgress, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Context from '../../context/Context';
import DeleteConfirm from '../../Common/DeleteConfirm';
import { Plus } from 'lucide-react';
import apiClient from '../../utils/apiClient';

const DisplayEmployees = () => {
    const { isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete,
        confirmDelete } = useContext(Context);
    const navigate = useNavigate()
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);

    const getAllEmployees = async () => {
        setLoading(true)
        try {
            const res = await apiClient.get('/employee/getallemployees');
            if (res?.data?.status === true) {
                setEmployees(res?.data?.data);
            }

        } catch (error) {
            setError("Error fetching employees:");
            console.error(error);
        } finally {
            setLoading(false)
        }
    };

    const handleEdit = (employee) => {
        navigate('/create-edit-employee', { state: employee })
    };

    const handleDelete = async () => {
        setIsConfirmDeleteModelOpen(false)
        try {
            const res = await apiClient.delete(`/employee/deleteemployee/${itemIdToDelete}`);
            if (res.data.status === true) {
                setEmployees((prev) => prev.filter((e) => e.id !== itemIdToDelete));
                toast.success(res.data.message)
                getAllEmployees()
            }
        } catch (error) {
            setError("Error deleting employee:");
            console.error(error);
        }
    };

    useEffect(() => {
        getAllEmployees();
    }, []);

    return (
        <>
            <Box m={2} p={0.5}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} my={2}>
                    <Typography variant="h4" fontWeight={400}  >
                        Employees List
                    </Typography>
                    <Button variant="contained" color="primary" onClick={() => navigate('/create-edit-employee')}
                        sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}>

                        <Plus size={23} />
                        <Typography>Add Employee</Typography>
                    </Button>
                </Box>
                <Divider sx={{ mb: 2 }} />
                {loading ? (
                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        height: '300px',
                    }}>
                        <CircularProgress color="primary" />
                    </Box>
                ) : (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>SNo</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Mobile</TableCell>
                                    <TableCell>Role</TableCell>
                                    <TableCell>Active</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {employees.map((emp, index) => (
                                    <TableRow key={emp.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{emp.name}</TableCell>
                                        <TableCell>{emp.email}</TableCell>
                                        <TableCell>{emp.mobile}</TableCell>
                                        <TableCell>{emp.role?.name}</TableCell>
                                        <TableCell>{emp.isActive ? "Yes" : "No"}</TableCell>
                                        <TableCell>
                                            <IconButton
                                                aria-label="edit"
                                                color=""
                                                onClick={() => handleEdit(emp)}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                aria-label="delete"
                                                color="error"
                                                onClick={() => confirmDelete(emp.id)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {employees.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">
                                            No employees found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>

            {
                error && (
                    <Typography variant='body2' color='error'>{error}</Typography>)
            }

            <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
        </>
    );
};

export default DisplayEmployees;
